import { Box, Icon, Text } from '@nimbus-ds/components';
import { ChevronRightIcon } from '@nimbus-ds/icons';

interface InfoDomainCardProps {
  title: string;
  description: string;
  onClick?: () => void;
}

function InfoDomainCard({
  title,
  description,
  onClick,
}: Readonly<InfoDomainCardProps>) {
  return (
    <Box
      borderColor="primary-interactive"
      borderStyle="solid"
      borderWidth="1"
      borderRadius="2"
      padding="4"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      cursor={onClick ? 'pointer' : undefined}
      onClick={onClick}
    >
      <Box display="flex" flexDirection="column">
        <Text fontSize="base" color="neutral-textHigh">
          {title}
        </Text>
        <Text fontSize="caption" color="neutral-textLow">
          {description}
        </Text>
      </Box>
      <Icon source={<ChevronRightIcon />} color="primary-interactive" />
    </Box>
  );
}

export default InfoDomainCard;
